"use client";
import React from "react";
import { motion } from "framer-motion";
import {
  FaBook,
  FaClipboardList,
  FaUserGraduate,
  FaFileAlt,
  FaBrain,
  FaClock,
  FaChalkboardTeacher,
  FaVideo,
  FaTasks,
  FaChartBar,
} from "react-icons/fa";

const AptitudeLab = () => {
  return (
    <section className=" px-3 px-md-5 bg-white mr-50 ml-50">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className=""
      >
        {/* Title */}
        <h2 className="fs-1 fw-bold text-primary mb-3">Aptitude Lab</h2>
        <p className="text-black mb-5">
          The Aptitude Lab prepares students for company recruitment tests with
          practice in <span className="fw-semibold">quantitative</span>,{" "}
          <span className="fw-semibold">verbal</span>, and{" "}
          <span className="fw-semibold">reasoning</span> sections. It features
          timed, company-centric sample papers and detailed explanations to
          improve speed and accuracy.
        </p>

        {/* Features Grid */}
        <div className="row g-4">
          {[
            { icon: FaBook, title: "Foundations" },
            { icon: FaClipboardList, title: "Quantitative" },
            { icon: FaFileAlt, title: "Verbal" },
            { icon: FaBrain, title: "Reasoning" },
            { icon: FaClock, title: "Company-Centric Test Papers" },
            { icon: FaUserGraduate, title: "Generate Tests" },
          ].map((item, idx) => (
            <div key={idx} className="col-12 col-md-4">
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="bg-white shadow rounded-4 p-4 text-center h-100 d-flex flex-column align-items-center justify-content-center"
              >
                <item.icon className="fs-1 text-primary mb-3" />
                <h3 className="fs-5 fw-semibold text-dark">{item.title}</h3>
              </motion.div>
            </div>
          ))}
        </div>

        {/* Teacher Console Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-5 p-4 p-md-5 bg-white border rounded-4 shadow"
        >
          <div className="d-flex align-items-center gap-3 mb-4">
            <FaChalkboardTeacher className="text-primary fs-2" />
            <h3 className="fs-3 fw-bold text-primary">Teacher Console</h3>
          </div>

          <p className="text-black mb-4">
            Students are managed through the <strong>Teacher Console</strong>,
            which allows facilitators to monitor progress, add custom content
            (videos, PDFs), create lessons, schedule activities, and conduct
            assessments.
          </p>

          <ul className="row g-3 list-unstyled">
            {[
              { icon: FaUserGraduate, label: "Monitor student progress" },
              { icon: FaVideo, label: "Upload custom content" },
              { icon: FaBook, label: "Create interactive lessons" },
              { icon: FaClock, label: "Schedule activities" },
              { icon: FaTasks, label: "Conduct assessments" },
              { icon: FaChartBar, label: "Track analytics" },
            ].map((feature, idx) => (
              <li
                key={idx}
                className="col-12 col-sm-6 mt-2 col-md-4 d-flex align-items-center bg-light p-3 rounded shadow-sm"
              >
                <feature.icon className="text-primary me-2" />
                <span className="text-dark">{feature.label}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default AptitudeLab;
